// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_TeveUmProblemaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /wizard_servicos/teve_um_problema/{compromissoId}
 *
 * Reports a problem during a compromisso. No body required — compromissoId
 * is a URL path parameter.
 */
import { registerContract } from './validate'

export interface WizardServicos_TeveUmProblemaInput {}

registerContract('WizardServicos_TeveUmProblemaInput', {})
